import { Inject, Injectable, InjectionToken } from '@angular/core';

export const ESTENSA_MODULE_AUTHORIZATION_SERVICE = new InjectionToken(
    'estensa.module.authorization.service',
);

export interface IAuthorizationServiceNg1 {
    isAuthorized( authorizationList : string[], operator: string): boolean;
    hasPermission(permission : any): boolean;
    showDebugInfo(msg : string): void;
    askGoToLogin(msg : string): boolean;
}
@Injectable()
export class NullEstensaAuthorizationServiceService implements IAuthorizationServiceNg1 {
    
    constructor() {}

    isAuthorized() {
        return true;
    }

    hasPermission() {
        return true;
    }

    showDebugInfo() {
        return true;
    }

    askGoToLogin(): boolean {
        return true;
    }
}

@Injectable({
    providedIn: 'root',
})
export class EstensaAuthorizationServiceService implements IAuthorizationServiceNg1  {

    estensaWEB_Authentication = false;
    estensaWPF_Authentication = false;

    public permissions = {
        allDefaultReportGet: 'allDefaultReport_Get',
        allDefaultReportSet: 'allDefaultReport_Set',
        attachedDocumentGet: 'attachedDocument_Get',
        attachedDocumentSet: 'attachedDocument_Set',
        bookingExtended: 'bookingExtended',
        bookingGet: 'booking_Get',
        bookingSet: 'booking_Set',
        broker_BrokerOnDemandAccess: 'broker_BrokerOnDemandAccess',
        broker_PACSDataModificationEnabled: 'broker_PACSDataModificationEnabled',
        broker_StudyDeletionEnabled: 'broker_StudyDeletionEnabled',
        caseHistoryGet: 'caseHistory_Get',
        caseHistorySet: 'caseHistory_Set',
        configurationForSiteSet: 'configurationForSite_Set',
        customPageLayoutOnlyNotActiveGet: 'customPageLayout_OnlyNotActive_Get',
        dashboardGet: 'dashboard_Get',
        debugEnabled: 'debugEnabled',
        deliverabilitySet: 'deliverability_Set',
        deviceUnload: 'device_Unload',
        enableUnlockExaminations: 'enableUnlockExaminations',
        eprEventGet: 'eprEvent_Get',
        eprEventSearch: 'eprEvent_Search',
        examReassign: 'exam_Reassign',
        examinationDetailGet: 'examination_Detail_Get',
        examinationDetailSet: 'examination_Detail_Set',
        examinationEcgGet: 'examination_Ecg_Get',
        examinationExamGet: 'examination_Exam_Get',
        examinationExamSet: 'examination_Exam_Set',
        examinationSystemAuditor: 'examination_SystemAuditor',
        hospitalizationGet: 'hospitalization_Get',
        isTechnician: 'isTechnician',
        mammographicScreeningAdmin: 'mammographicScreening_Admin',
        mammographicScreeningGet: 'mammographicScreening_Get',
        mammographicScreeningSet: 'mammographicScreening_Set',
        mammographicScreeningUndoApproveReadOrReviewOtherReferring: 'mammographicScreening_UndoApproveReadOrReviewOtherReferring',
        mammographicScreening_FirstLevel_Reader_Get: 'mammographicScreening_FirstLevel_Reader_Get',
        mammographicScreening_FirstLevel_Reader_Set: 'mammographicScreening_FirstLevel_Reader_Set',
        mammographicScreening_FirstLevel_Reviewer_Get: 'mammographicScreening_FirstLevel_Reviewer_Get',
        mammographicScreening_FirstLevel_Reviewer_Set: 'mammographicScreening_FirstLevel_Reviewer_Set',
        mediaPrint: 'media_Print',
        modulePrint: 'module_Print',
        openNewTab: 'openNewTab',
        orderGet: 'order_Get',
        orderEvasionSet: 'order_Evasion_Set',
        orderManagementSet: 'order_Management_Set',
        patientGet: 'patient_Get',
        patientMerge: 'patient_Merge',
        patientSet: 'patient_Set',
        publicationGet: 'publication_Get',
        publicationSet: 'publication_Set',
        reportDelete: 'report_Delete',
        reportGet: 'report_Get',
        reportSet: 'report_Set',
        viewerGet: 'viewer_Get',
        viewerInEmergencyGet: 'viewerInEmergency_Get',
        viewScheduling: 'viewScheduling',
    };

    constructor(
        @Inject(ESTENSA_MODULE_AUTHORIZATION_SERVICE)
        private authenticationService: IAuthorizationServiceNg1,
    ) {}

    isAuthorized(authorizationList : string[], operator: string) : boolean {
        return this.authenticationService.isAuthorized(authorizationList, operator);
    }

    hasPermission(permission : any) : boolean {
        return this.authenticationService.hasPermission(permission);
    }

    showDebugInfo(msg : string) {
        return this.authenticationService.showDebugInfo(msg);
    }

    askGoToLogin(msg : string): boolean {
        return this.authenticationService.askGoToLogin(msg);
    }


}
